<template>
  <div>
    <common-dialog
      ref="dialog"
      width="1300px"
      unit="工序详情"
      id-key="UserId"
      in-dialog
      @close-saved="$emit('close-saved')"
    >
      <el-table
        border
        class="table_bottom table-line tb-c-head"
        :data="tableData"
      >
      
      <el-table-column
        prop="ProductName"
        label="产品名称"
        min-width="120"
      ></el-table-column>
      <el-table-column
        prop="ProgrammeName"
        label="工艺方案名称"
        min-width="120"
      >
      </el-table-column>
      <el-table-column
        prop="ProcessSn"
        label="工序顺序"
        min-width="120"
      ></el-table-column>
      <el-table-column prop="ProcessName" label="工序名称" min-width="120">
      </el-table-column>
      <el-table-column
        prop="ProductionType"
        label="自制工序或者委外工序"
        min-width="120"
      >
        <template slot-scope="{ row }">
          <span>{{row.ProcessType === 0 ? '自制工序' : '委外工序'}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="TradeUnitName" label="委外供应商" min-width="120">
      </el-table-column>
      </el-table>



      <come-list-dialog
        @select="comeSelect"
        selectable
        :multiple="false"
        ref="comeListDialog"
        in-dialog
      />
    </common-dialog>

  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import comeListDialog from "@/components/basedata/business/come/listDialog";



export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    comeListDialog,
  },
  data() {
    return {
     tableData: [],
     currentRow: null
    };
  },
  methods: {
    selectCome(row){
      this.currentRow = row;
      this.$refs.comeListDialog.open()
    },
    changeProcessType(row){
      if(row.T !== 0){
        row.T = 1;
      }
    },
    comeSelect(row) {
      console.log('row', row)
      this.currentRow.DpId = row.TradeUnitId;
      this.currentRow.TradeUnitName = row.FullName;
      if(this.currentRow.T !== 0){
        this.currentRow.T = 1;
      }
    },
    setTableData(row){
      let arr = [];
      let o = {
        ProductName: row.ProductName,
        ProgrammeName: row.ProgrammeName,
        ProcessSn: row.ProcessSn,
        ProcessId: row.ProcessId,
        ProcessName: row.ProcessName,
        ProcessNo: row.ProcessNo,
        ProgrammeId: row.ProgrammeId,
        ProgrammeName: row.ProgrammeName,
        ProgrammeProcessId: row.ProgrammeProcessId,
        Stage: row.Stage,
        ProcessType: row.ProcessType,
        TradeUnitId: row.TradeUnitId,
        TradeUnitName: row.TradeUnitName,
      }
      arr.push(o);
      this.tableData = arr;
      console.log('set tableData', this.tableData)
    },
    save(){
      console.log('this.tableData',this.tableData)

      let data = this.tableData.filter(item => {
        return item.T != null
      })
      console.log('data',data)
      this.$emit('saved', data)
      this.close();
    }
  }
 
};
</script>

<style lang="scss" scoped>
.flex {
  display: flex;
}
</style>
